var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "top" }, [
      _c(
        "div",
        { staticClass: "top_todolist" },
        [
          _c("div", { staticClass: "top_title_dv" }, [
            _vm._m(0),
            _c("div", { staticClass: "top_more", on: { click: _vm.getMore } }, [
              _c("span", [_vm._v("More")]),
            ]),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.todolists,
                "show-header": false,
                "max-height": "354px",
              },
            },
            [
              _c(
                "el-table-column",
                { attrs: { width: "80" } },
                [
                  [
                    _c("div", { staticClass: "icon" }, [
                      _c("span", { staticClass: "icon-daibanshixiang1" }),
                    ]),
                  ],
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { prop: "workflowDesc" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "item_lf" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: scope.row.workflowDesc,
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "item_content",
                                    on: {
                                      click: function ($event) {
                                        return _vm.detailClick(
                                          scope.row.taskType,
                                          scope.row.bizId,
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(scope.row.workflowDesc) + " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c("p", { staticClass: "item_info" }, [
                              _c("span", [
                                _vm._v(_vm._s("No: " + scope.row.bizNo)),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s("Creator: ") +
                                    _vm._s(
                                      +scope.row.creatorName === null
                                        ? ""
                                        : scope.row.creatorName
                                    )
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    "Create Date: " +
                                      scope.row.createDate.split(".")[0]
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "top_echart" }, [
        _vm._m(1),
        _c("div", {
          ref: "Echart",
          staticClass: "myChart",
          attrs: { id: "myChart" },
        }),
        _c("p", { staticClass: "top_echart_tip" }, [
          _vm._v("*All food categories as of current year"),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "chart_info" }, [
        _vm._m(2),
        _c("div", { staticClass: "chart_info_rg" }, [
          _c(
            "div",
            { staticClass: "task" },
            [
              _c("span", [_vm._v("Task: ")]),
              _vm._v("   "),
              _c("ic-select", {
                staticStyle: { display: "inline-block" },
                attrs: {
                  clearable: "",
                  table: "DASHBOARD",
                  field: "TASK_TYPE",
                  placeholder: _vm.$t("BC.sel"),
                },
                on: {
                  change: function ($event) {
                    return _vm.taskChange(_vm.taskType)
                  },
                },
                model: {
                  value: _vm.taskType,
                  callback: function ($$v) {
                    _vm.taskType = $$v
                  },
                  expression: "taskType",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("span", [_vm._v("Status: ")]),
              _vm._v("   "),
              _c("ic-select", {
                staticStyle: { display: "inline-block" },
                attrs: {
                  clearable: "",
                  table: "DASHBOARD",
                  field: "TASK_STATUS",
                  placeholder: _vm.$t("BC.sel"),
                },
                on: {
                  change: function ($event) {
                    return _vm.statusChange(_vm.taskStatus)
                  },
                },
                model: {
                  value: _vm.taskStatus,
                  callback: function ($$v) {
                    _vm.taskStatus = $$v
                  },
                  expression: "taskStatus",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("div", {
        ref: "Echart",
        staticClass: "barChart",
        attrs: { id: "barChart" },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "top_title_icon" }, [
      _c("span", { staticClass: "el-icon-alarm-clock clock" }),
      _vm._v("   "),
      _c(
        "span",
        {
          staticStyle: {
            color: "#f8ab01",
            "font-weight": "bold",
            "font-size": "18px",
          },
        },
        [_vm._v("To Do List")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "top_echart_dv" }, [
      _c("span", { staticClass: "el-icon-pie-chart chart" }),
      _vm._v("   "),
      _c(
        "span",
        { staticStyle: { "font-weight": "bold", "font-size": "18px" } },
        [_vm._v("FPA - Capital Distribution")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chart_info_lf" }, [
      _c("span", { staticClass: "el-icon-s-data data" }),
      _vm._v("   "),
      _c(
        "span",
        {
          staticStyle: {
            color: "#f8ab01",
            "font-weight": "bold",
            "font-size": "18px",
          },
        },
        [_vm._v("Statistics")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }